"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jlDataUtils_1 = require("../../utils/jlDataUtils");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const KevelAnalytics = ({ adId, type, clickUrl, impressionUrl, }) => {
    (0, react_1.useEffect)(() => {
        let eventListener = null;
        if (adId && type && clickUrl && impressionUrl) {
            const eventData = { adId, type, clickUrl, impressionUrl };
            (0, jlDataUtils_1.addKevelBannerToJlData)(eventData);
            const impressionEventData = Object.assign({ action: "kevel.impression" }, eventData);
            if (window && window.Bootstrapper && window.Bootstrapper.ensEventsReady) {
                (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(impressionEventData);
            }
            else {
                eventListener = () => (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(impressionEventData);
                document.body.addEventListener("ensEventsReady", eventListener, {
                    once: true,
                });
            }
        }
        else {
            (0, jlDataUtils_1.clearKevelBannersFromJlData)();
        }
        return () => {
            (0, jlDataUtils_1.clearKevelBannersFromJlData)();
            if (eventListener) {
                document.body.removeEventListener("ensEventsReady", eventListener);
            }
        };
    }, [adId, type, clickUrl, impressionUrl]);
    return null;
};
exports.default = KevelAnalytics;
